import NavBar from 'components/navbar/NavBar'
import Footer from '../components/footer/Footer'

import Header from 'components/typography/Header'
import headerLvl from '../components/typography/styles/Header.css'

import styles from './styles/Error.css'
import classNames from '../../node_modules/classnames/index'
import Btn from '../components/forms/styles/Button.css'
import { Link } from '../components/misc/Link'

const errorMessages = {
  404: 'Sorry, we couldn’t find that.',
  401: 'You need to be logged in to see this.',
  403: 'Hey, no peeking!',
  451: 'The request has been blocked, and please modify your input.'
}

export const Error = ({ status }) => (
  <div>
    <NavBar staticPage />
    <div className={styles.error}>
      {status && (
        <Header level={1} className={headerLvl.h2}>
          {status}
        </Header>
      )}
      <Header level={2}>{errorMessages[status] || 'Something went wrong!'}</Header>
      <img
        alt='skeptical pete'
        className={styles.errorImage}
        src={`${CONFIG.assetsBaseURL}/images/pete-skeptical.png`}
      />
      <div className={classNames(styles.buttonLayout)}>
        <Link className={classNames(styles.button, Btn['btn--blue'], Btn.btn, Btn['size--medium'])} to='/'>
          Visit homepage
        </Link>
      </div>
    </div>
    <Footer />
  </div>
)

export default Error
